import belsoftCore from '../../index.ts';
import AppSettings from '../../../webConfig';

export default class TapuService {

  
    validateUser = async (userName: string, password: string): Promise<any> => {
        const request = { userName, password };
        return (await belsoftCore.api.axios.post(`/api/ValidateUser`, request));
    };

    getUserInfo = async (userName: string): Promise<any> => {
        const request = { userName };
        return (await belsoftCore.api.axios.post(`/api/GetUserInfo`, request));
    };

    getEstateDeclarationsByRegistryAndEstateInfo = async (idType: string, idNo: string, blockOfBuildings: string, parcel: string, isOnlyActive: string, year: string, month: string, day: string, declarationStatus: string,): Promise<any> => {
        const request = { idType, idNo, blockOfBuildings, parcel, isOnlyActive, year, month, day, declarationStatus };
        return (await belsoftCore.api.axios.post(`/api/GetEstateDeclarationsByRegistryAndEstateInfo`, request));
    };

    getCityList = async (): Promise<any> => {
        return (await belsoftCore.api.axios.post(`/api/GetCityList`));
    };

    retrieveCurrentMarketValueReportParameter = async (): Promise<any> => {
        return (await belsoftCore.api.axios.post(`/api/RetrieveCurrentMarketValueReportParameter`));
    };

    getNextCurrentMarketValueReportNumber = async (): Promise<any> => {
        return (await belsoftCore.api.axios.post(`/api/GetNextCurrentMarketValueReportNumber`));
    };

    retrieveParametersWithoutAuthorization = async (parameterTypeCode: string): Promise<any> => {
        const request = { parameterTypeCode };
        return (await belsoftCore.api.axios.post(`/api/RetrieveParametersWithoutAuthorization`, request));
    };

    getConcreteEstateDeclarationRegistry = async (concreteRegistry: any): Promise<any> => {
        const request = { concreteRegistry };
        return (await belsoftCore.api.axios.post(`/api/GetConcreteEstateDeclarationRegistry`, request));
    };

    saveCurrentMarketValueReportParameter = async (concreteCurrentMarketValueReportParameter: any): Promise<any> => {
        const request = { concreteCurrentMarketValueReportParameter };
        return (await belsoftCore.api.axios.post(`/api/SaveCurrentMarketValueReportParameter`, request));
    };

    createMarketValueReport = async (concreteCurrentMarketValueReport: any,reportType:string): Promise<any> => {
        const request = { concreteCurrentMarketValueReport,reportType };
        return (await belsoftCore.api.axios.post(`/api/CreateMarketValueReport`, request));
    };

    retrieveCmvReportDetails = async (estateDeclarationRegistryOid: any): Promise<any> => {
        const request = { estateDeclarationRegistryOid };
        return (await belsoftCore.api.axios.post(`/api/RetrieveCmvReportDetails`, request));
    };

    checkCurrentMarketValueReportDeclarationDebt = async (concreteCurrentMarketValueReport: any): Promise<any> => {
        const request = { concreteCurrentMarketValueReport };
        return (await belsoftCore.api.axios.post(`/api/CheckCurrentMarketValueReportDeclarationDebt`, request));
    };

    getDeclarationAccrumentDetail = async (estateDeclarationOid: any): Promise<any> => {
        const request = { estateDeclarationOid };
        return (await belsoftCore.api.axios.post(`/api/GetDeclarationAccrumentDetail`, request));
    };

    getUser = async (): Promise<any> => {
        const request = { applicationName: AppSettings.ApplicationName };
        return (await belsoftCore.api.axios.post(`/api/GetUser`, request));
    };

    retrieveBranches = async (): Promise<any> => {
        return (await belsoftCore.api.axios.post(`/api/RetrieveBranches`));
    };

    getAllDepartments = async (): Promise<any> => {
        return (await belsoftCore.api.axios.post(`/api/GetAllDepartments`));
    };

    retrieveRoles = async (): Promise<any> => {
        return (await belsoftCore.api.axios.post(`/api/RetrieveRoles`));
    };

    changePassword = async (userName: string, newPassword: string, applicationName: string, canBeChangeThePassword: string, validationKey: string): Promise<any> => {
        const request = { userName, newPassword, applicationName, canBeChangeThePassword, validationKey };
        return (await belsoftCore.api.axios.post(`/api/ChangePassword`, request));
    };
}